export default "__VITE_ASSET__18cf6dec__"